const instructions = {
    table: {
      user: "Manage user profiles: Search users, check profile details and manage premium memberships.",
      
      team: "Manage teams: Create, update, and delete teams.",
      
      league: "Manage global league settings: Create leagues, update leagues, generate team hub stats, start and end leagues.",
      
      leagueManagement: "Manage league sub-resources: Manage teams, fixtures and users within leagues."
    }
  };

  export default instructions;
  